import { UPDATE_USER_REQUEST, UPDATE_USER_SUCCESS, UPDATE_USER_ERROR } from '../constants/ActionTypes';

export function isUpdatingUserInfo(state = false, action) {
    switch (action.type) {
        case UPDATE_USER_REQUEST:
            return true;
        case UPDATE_USER_SUCCESS:
        case UPDATE_USER_ERROR:
            return false;
    }
    return state;
}

export function updateUserInfoError(state = false, action) {
    switch (action.type) {
        case UPDATE_USER_REQUEST:
        case UPDATE_USER_SUCCESS:
            return false;
        case UPDATE_USER_ERROR:
            return true;
    }
    return state;
}